import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-group-escalation',
  templateUrl: './group-escalation.component.html',
  styleUrls: ['./group-escalation.component.scss']
})
export class GroupEscalationComponent implements OnInit {

  id?: number;
  group: any;
  escalation:any = null;
  edit_view:string = '';
  editing = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }


  ngOnInit(): void {

    this.id = +this.route.snapshot.params['id'];

    //console.log(this.id);

    this.getEscalation();

    this.getGroup();


  }

  getEscalation(){

    this.okService.get("escalation/group/"+this.id,[])
    .subscribe((data:any) => {

      this.escalation = data.body;

      //console.log(this.escalation);
    })
  }
  getGroup(){

    this.okService.get("groups/"+this.id,{expand:'workers'})
    .subscribe((data) => {

      this.group = data.body;
    })

  }

  chooseEdit(view:string){
    //console.log(view);
    this.editing = true;
    this.edit_view = view;

  }


  onCompleted(completed: any) {

    //console.log(completed);
    this.editing = false;
    if(completed){
      this.getEscalation();
      this.okService.setAlert(this.transloco.translate("Your escalation procedure has been updated"),"success");
    }
  }

  deleteEscalation(){
    if(confirm(this.transloco.translate("Are you sure you want to delete the group escalation?"))) {


      this.okService.put('escalation/group/'+this.id,{'text':''})
      .subscribe((data) => {

        this.getEscalation();

        this.okService.setAlert(this.transloco.translate("The group escalation procedure has been removed"),"success");

      });


    }
  }


}
